/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @generated SignedSource<<58d6ad998213d154ce9d78cb85e8b9bd>>
 *
 * Generated by LanguageCLDRGenScript
 *
 * 
 */
'use strict';

var IntlVariations = require("./IntlVariations");

var IntlCLDRNumberType04 = {
  getVariation: function getVariation(n) {
    if (n >= 0 && n <= 1) {
      return IntlVariations.NUMBER_ONE;
    } else {
      return IntlVariations.NUMBER_OTHER;
    }
  }
};
module.exports = IntlCLDRNumberType04;